import { configureStore } from '@reduxjs/toolkit';
import modelReducer from './modelSlice';

const store = configureStore({
  reducer: {
    model: modelReducer, // Add slices here
  },
});

export default store;
